import { createFileRoute } from '@tanstack/react-router';
import { scoringConfigsQueryOptions } from '@/features/settings/api';
import { ScoringPage } from '@/features/settings/scoring/ScoringPage';

export const Route = createFileRoute('/_auth/settings/scoring')({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(scoringConfigsQueryOptions()).catch(() => undefined),
  component: ScoringPage,
});
